module.exports = __webpack_public_path__ + "img/3-Material particulado.cc7d88c6.png";